var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55248 6.34944V7.98003C7.55248 9.33885 7.00895 9.88238 5.65013 9.88238H4.01954C2.66072 9.88238 2.11719 9.33885 2.11719 7.98003V6.34944C2.11719 4.99062 2.66072 4.44709 4.01954 4.44709H5.65013C7.00895 4.44709 7.55248 4.99062 7.55248 6.34944Z",
    fill: "#FFE1CE",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97954 2.11768H6.34895C5.10824 2.11768 4.55044 2.57406 4.46262 3.68431C4.45059 3.83646 4.57517 3.96179 4.72779 3.96179H5.65013C7.28072 3.96179 8.03778 4.71885 8.03778 6.34944V7.27178C8.03778 7.4244 8.16311 7.54898 8.31526 7.53695C9.42551 7.44913 9.88189 6.89133 9.88189 5.65062V4.02003C9.88189 2.66121 9.33836 2.11768 7.97954 2.11768Z",
    fill: "#FFE1CE",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.116043050677510db1804feac45eee5d.svg";
export { ForwardRef as ReactComponent };